import { z } from "zod";
import { COLORS } from "../../colors";

export const textValuesFormSchema = z.object({
	text: z.string().optional(),
	color: z.enum(COLORS),
});

export type TextValuesFormSchema = z.infer<typeof textValuesFormSchema>;
